module.exports = __webpack_public_path__ + "static/Lato-Regular-7f690e503a254e0b8349aec0177e07aa.ttf";